import React, { Fragment } from 'react';
import classNames from 'classnames';
import typ from 'design-v2/globals/typography.module.css';
import style from 'design-v2/common/BCComponentWrapper/style.module.css';
import { IBCCComponentContainerProps } from 'design-v2/common/BCComponentWrapper/types';

const BCComponentWrapper = (props: IBCCComponentContainerProps) => {
  return (
    <div
      className={classNames({
        [style.wrapperRoot]: true,
        [style.warningBorder]: props.showWarning,
      })}
      style={props.containerStyle}
      ref={props.containerRef}
      data-testid={props.containerTestId || 'bc-component-wrapper'}
    >
      {props.componentAboveHeader && <Fragment>{props.componentAboveHeader}</Fragment>}
      {(!!props.title || !!props.headerTail) && !props.isHiddenTitle && (
        <div
          className={classNames({
            [style.wrapperHeader]: true,
          })}
          style={props.headerStyle}
          data-testid={props.headerTestId || 'bc-component-wrapper-header'}
        >
          {/*if no title only headerTail, headerTail can decide whole header content*/}
          {!!props.title && (
            <span
              className={classNames({
                [style.label]: true,
                [typ.typSize2]: true,
                [typ.typBold]: true,
              })}
              style={props.titleStyle}
              data-testid={props.titleTestId || 'bc-component-wrapper-header-title'}
            >
              {props.title}
            </span>
          )}
          {props.headerTail}
        </div>
      )}
      <Fragment>{props.children}</Fragment>
    </div>
  );
};

export default BCComponentWrapper;
